import React from "react"
import { useLocation, NavLink } from "react-router-dom";
import { useEffect, useState } from "react"
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Modal
} from "react-bootstrap";
import { Link } from 'react-router-dom';
import BonusCreateModal from "components/Bonus/BonusCreateModal"
import toast, { Toaster } from "react-hot-toast"
import API from "components/Apis/API"
import { apiUrl } from 'config';
 
const BonusMain = () => {
  const [createModal, setCreateModal] = useState(false);
  const [Periods, setPeriods] = useState([]);
  const [Primary, setPrimary] = useState({});

  const fetchData = async () =>
  {
    const toastId = toast.loading("Loading data...")
    const url = "admin/bonus/periods"
    const response = await API.getData(url)
    const data = response
    if (data.status) {
      setPeriods(data.data.periods)
      setPrimary(data.data.primary)
    }
    toast.dismiss(toastId)
  }
  useEffect(() => {
    fetchData()
  }, [])




  const freezePeriod = async (tid,pid) =>
  {
    const toastId  = toast.loading("Freezing period...")
    const url      = "admin/bonus/periods/"+pid+"/freeze"
    const response = await API.getData(url)
    const data     = response
    if (data.status) {
      setPeriods(data.data.periods)
      setPrimary(data.data.primary)

    }
    toast.dismiss(toastId)
    toast.dismiss(tid)
  }

  const retryJobs = async (pid,job) =>
    {
      const toastId  = toast.loading("Retrying jobs...")
      const url      = "admin/bonus/periods/"+pid+"/retry_jobs/"+job
      const response = await API.getData(url)
      const data     = response
      if (data.status) {
        toast.success("Jobs in progress");
      }
      toast.dismiss(toastId)
    }
  const makePrimary = async (pid) =>
  {
    const toastId  = toast.loading("Changing primary period...")
    const url      = "admin/bonus/periods/"+pid+"/primary"
    const response = await API.getData(url)
    const data     = response
    if (data.status) {
      setPeriods(data.data.periods)
      setPrimary(data.data.primary)

    }
    toast.dismiss(toastId)
  }
  const askFreeze = async (pid) => {
    console.log(pid)
    toast(
      (t) => (
        <span style={{ textAlign: "center" }}>
          Do you really want to freeze this period? only a developer can unfreeze it back.<br></br>
          <button
            className='btn btn-primary btn-xs'
            onClick={() => freezePeriod(t.id, pid)}
          >
            Yes
          </button>
          <button
            className='btn btn-primary btn-xs'
            onClick={() => toast.dismiss(t.id)}
          >
            No
          </button>
        </span>
      )
    )
  }

  return (
    <>
    <Toaster position='bottom-right' />
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">
                  Manage Periods
                  <button
                      className='btn btn-primary btn-sm tbtn terminal_1'
                      style={{ margin: "5px", float: "right" }}
                      onClick={() => setCreateModal(true)}
                  >Create</button>

                  {Primary.id != undefined ? (
                    <Link style={{ margin: "5px", float: "right" }} className="btn btn-sm" to={`/admin/app/bonus-manage/${Primary.id}`}>Manage Primary</Link>

                  ) : (
                    <Link style={{ margin: "5px", float: "right" }} className="btn btn-sm" disabled>Primary Does Not Exist</Link>

                  ) }
                
                </Card.Title>
                <p className="card-category">
                  Create or download your calculated reports
                </p>

              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped table">
                  <thead>
                    <tr>
                      <th className="border-0">ID</th>
                      <th className="border-0">Name</th>
                      <th className="border-0">Description</th>
                      <th className="border-0">Start Date</th>
                      <th className="border-0">End Date</th>
                      <th className="border-0">Status</th>
                      <th className="border-0">Created At</th>
                      <th className="border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {Periods.map((row, i) => (
                    <tr>
                      <td>{row.id}</td>
                      <td>{row.name}</td>
                      <td>{row.description}</td>
                      <td>{row.start_date}</td>
                      <td>{row.end_date}</td>
                      <td>

                        {row.b100_status == 1 ? (

                          <span className="badge badge-success">
                            <a style={{color:"white"}} target="_blank" href={apiUrl+"admin/bonus/result/download/"+row.id+"/b100"}>B100</a>
                          </span>
                          

                        ) : (
                          <span className="badge badge-danger">B100
                          <a style={{color:"white"}} href="#" onClick={()=>retryJobs(row.id,"b100")}> <i className="fa fa-sync"></i></a>
                          </span>
                        )}

                          {row.b085_status == 1 ? (

                          <span className="badge badge-success">
                            <a style={{color:"white"}} target="_blank" href={apiUrl+"admin/bonus/result/download/"+row.id+"/b085"}>B085</a>
                          </span>


                          ) : (
                          <span className="badge badge-danger">B085
                            <a style={{color:"white"}} href="#" onClick={()=>retryJobs(row.id,"b085")}> <i className="fa fa-sync"></i></a>
                          </span>
                          )}

                          {row.chart_status == 1 ? (
                            <span className="badge badge-success">Org Chart</span>
                          ) : (
                            <span className="badge badge-danger">Org Chart</span>
                          )}
                        

                      </td>
                      <td>{row.created_at}</td>

                      <td>

                        {row.b100_status == 1 && row.b085_status == 1 ? (
                          <>
                          <Link className="btn btn-xs" to={`/admin/app/bonus-manage/${row.id}`}>Manage</Link>

                          {row.freezed == 0 && row.is_primary == 0 ? (
                          
                          <Link className="btn btn-xs" onClick={()=>askFreeze(row.id)}>Freeze</Link>
                          ) : 
                          (
                            <Link className="btn btn-danger btn-xs" disabled>Freezed</Link>
                          )}

                          {row.is_primary == 0 ? (
                            <Link className="btn btn-xs" onClick={()=>makePrimary(row.id)}>Make Primary</Link>
                          ) : 
                          (
                            <Link className="btn btn-danger btn-xs" disabled>Primary</Link>
                          )}
                          </>


                        ) : ("Not Completed")}
                       
                        

                      </td>
                    </tr>
                  ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          
        </Row>
      </Container>

      <BonusCreateModal Periods={Periods} Primary={Primary} setPrimary={setPrimary} setPeriods={setPeriods} show={createModal} close={() => setCreateModal(false)} />
  
    </>
  );
}

export default BonusMain;
